Ext.define('SA.HiddenDom', {
    singleton: true,

    initialize() {
        this.container = SA.Html.create({type: 'div', class: 'sa-hidden-dom'});

        document.body.append(this.container);
    },

    attach(el) {
        return this.container.appendChild(el);
    },

    getContainer() {
        return this.container;
    }
});